import { GetterTree } from 'vuex';
import { State } from '@/store/modules/alertV2/extTagGrouping/extTagGrouping.store';
import { defaultErrorValues } from '@/components/AlertsV2/external-tag-grouping/extTags.types';
const getters: GetterTree<State, State> = {
  getExtTagTableInfo(state: State) {
    return state.extTagTableInfo;
  },
  getExtTagFormUtilReloadTable(state: State) {
    return state.formUtils.reloadExtTagTable;
  },
  getWebhookMapping(state: State) {
    return state.webhookMapping;
  },
  getExtTagFormData: (state: State) => {
    return state.extTagFormData;
  },
  getExtTagFields: (state: State) => {
    return state.extTagFormData.extTagFields;
  },
  getExtTagConditions: (state: State) => {
    return state.extTagFormData.extTagConditions;
  },
  getTagInfo: (state: State) => {
    return state.extTagFormData.tagInfo;
  },
  getIsErrorInForm: (state: State) => {
    return state.isErrorInForm;
  },
  getIsExtTagFormEdit: (state: State) => {
    return state.isExtTagFormEdit;
  },
};

export default getters;
